import BaseComponent from './BaseComponent';
import { selectMatchingVideoSource } from '../utils';

let components = [];

class VideoPlayer extends BaseComponent {
	constructor(el) {
		super();

		if (!'ResizeObserver' in window) {
			return;
		}

		this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));

		this.el = el;
		this.video = this.el.querySelector('[data-video]');
		this.poster = this.el.querySelector('[data-poster]');
		this.playButton = this.el.querySelector('[data-play-button]');

		this.playButton.addEventListener('click', (e) => {
			const isPlaying = !this.video.paused;
			if (!isPlaying) {
				this.el.dispatchEvent(new CustomEvent('play-video'));
				this.playButton.setAttribute('tabindex', -1);
				this.video.removeAttribute('tabindex');
				this.video.focus({
					preventScroll: true,
				});
			}
		});

		this.init();
	}

	init() {
		new Video(this);
		this.resizeObserver.observe(this.el);
	}

	handleResize(entries) {
		entries.forEach((entry) => {
			const target = entry.target;
			if (!target.classList.contains('dont-update-my-source')) {
				target.dispatchEvent(new CustomEvent('select-source'));
			}
		});
	}

	destroy() {
		super.destroy();

		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}

		if (this.player) {
			this.player.destroy();
		}
	}
}

document.addEventListener('bless', (e) => {
	components.forEach((component) => component.destroy());
	components = [];

	const container = e.detail?.next?.container;

	if (!container) {
		return;
	}

	[...container.querySelectorAll('[data-video-player]')].forEach((element) => {
		components.push(new VideoPlayer(element));
	});
});

class Video {
	constructor(module) {
		this.module = module;

		this.video = this.module.el.querySelector('video');
		if (!this.video) {
			return;
		}

		this.newTime = null;
		this.shouldPlay = false;

		this.module.el.addEventListener('select-source', () => {
			this.selectSource();
		});

		this.module.el.addEventListener('play-video', () => {
			this.shouldPlay = true;
			this.playVideo();
		});

		this.video.addEventListener('loadedmetadata', () => {
			if (this.newTime) {
				this.video.currentTime = this.newTime;
				this.newTime = null;
			}
		});

		this.video.addEventListener('pause', () => {
			this.shouldPlay = false;
		});

		this.video.addEventListener('play', () => {
			this.module.el.classList.add('is-playing');
			this.video.removeAttribute('inert');
		});
	}

	playVideo() {
		this.video.play();
	}

	selectSource() {
		this.oldTime = this.video.currentTime;
		selectMatchingVideoSource(this.video).then(() => {
			this.video.setAttribute('preload', 'metadata');
			this.newTime = this.oldTime;
			if (this.shouldPlay) {
				this.playVideo();
			}
		});
	}
}

export const videoPlayers = [...document.querySelectorAll('[data-video-player]')].map((el) => {
	return new VideoPlayer(el);
});
